/**
 * Holat → KASSIRGA ANIQ ISH. Sof xarita, komponentdan ajratilgan.
 *
 * =====================================================================
 * ⛔ NEGA ALOHIDA FAYL
 * =====================================================================
 * `idempotencyHolder.ts` dagi bilan bir xil sabab: JSX ichida turganda
 * bu xaritani faqat MATN bo'yicha tekshirish mumkin bo'lardi — ikkita
 * holat bir xil kalitga ulansa ham qorovul yashil qolardi. Bu yerda
 * qorovul xaritaning O'ZINI chaqiradi va sakkizala holatni sanaydi.
 *
 * =====================================================================
 * ⚠️ «QIZIL» KAM ISHLATILADI — `useCashOperation` dagi qoidaning aynan
 * takrori
 * =====================================================================
 * Server ANIQ javob bergan holat (karta ishlatilgan, muddati o'tgan,
 * bekor qilingan, kod yo'q) texnik xato EMAS va qizil ko'rsatilsa
 * kassir tugmani qayta-qayta bosadi — javob esa har safar bir xil
 * bo'ladi. Qizil FAQAT tizim nuqsonida: kartaning plani katalogdan
 * yo'qolgan bo'lsa, uni kassir ham, mijoz ham tuzata olmaydi va
 * kimdir XABAR BERISHI kerak.
 */

import type { ActivationVerdict } from './voucherApi'

export type VoucherVerdictKind = ActivationVerdict['kind']

export interface VoucherAdvice {
  /** antd `Alert` turi */
  tone: 'success' | 'warning' | 'error'
  /** Nima bo'ldi */
  titleKey: string
  /** ⚠️ Endi NIMA QILISH kerak — bannerning eng qimmatli qatori */
  adviceKey: string
  /**
   * Karta bazada O'ZGARMAGANMI.
   *
   * ⚠️ O'lchangan: `VoucherServiceImpl.activate` `@Transactional` va
   * `NOT_FOUND` / `LOGIN_CLOSED` / `PLAN_UNAVAILABLE` uchtasi ham
   * shartli `UPDATE` dan OLDIN tashlanadi, ya'ni yozuv qaytariladi.
   * Kassirga buni aytish mijozning pulini saqlaydi: aks holda u
   * yaroqli kartani chiqarib tashlardi.
   */
  cardIntact: boolean
}

/**
 * ⚠️ `Record` — `Partial<Record>` EMAS. Yangi holat qo'shilib, bu
 * yerga yozilmasa TypeScript yig'ishda to'xtatadi. `??` bilan
 * «standart» xabar qo'yilsa, yangi holat jimgina eski matn bilan
 * ko'rsatilardi.
 */
export const VOUCHER_ADVICE: Record<VoucherVerdictKind, VoucherAdvice> = {
  ACTIVATED: {
    tone: 'success',
    titleKey: 'vouchers.result.ACTIVATED',
    adviceKey: 'vouchers.advice.ACTIVATED',
    cardIntact: false,
  },
  /**
   * ⚠️ `USED` DAN AJRATILGAN VA BU BUTUN EKRANNING ENG MUHIM QATORI.
   * Tarmoq uzilib qayta bosilganda server AYNI `409` ni qaytaradi;
   * uni «karta ishlatilgan» deb ko'rsatish kassirni mijozga yolg'on
   * gap aytishga majbur qilardi. Dalil — `activationAttempt.ts`.
   */
  OWN_RETRY: {
    tone: 'warning',
    titleKey: 'vouchers.result.OWN_RETRY',
    adviceKey: 'vouchers.advice.OWN_RETRY',
    cardIntact: false,
  },
  USED: {
    tone: 'warning',
    titleKey: 'vouchers.result.USED',
    adviceKey: 'vouchers.advice.USED',
    cardIntact: false,
  },
  EXPIRED: {
    tone: 'warning',
    titleKey: 'vouchers.result.EXPIRED',
    adviceKey: 'vouchers.advice.EXPIRED',
    cardIntact: false,
  },
  VOIDED: {
    tone: 'warning',
    titleKey: 'vouchers.result.VOIDED',
    adviceKey: 'vouchers.advice.VOIDED',
    cardIntact: false,
  },
  NOT_FOUND: {
    tone: 'warning',
    titleKey: 'vouchers.result.NOT_FOUND',
    adviceKey: 'vouchers.advice.NOT_FOUND',
    cardIntact: true,
  },
  SUBSCRIBER_MISSING: {
    tone: 'warning',
    titleKey: 'vouchers.result.SUBSCRIBER_MISSING',
    adviceKey: 'vouchers.advice.SUBSCRIBER_MISSING',
    cardIntact: true,
  },
  LOGIN_CLOSED: {
    tone: 'warning',
    titleKey: 'vouchers.result.LOGIN_CLOSED',
    adviceKey: 'vouchers.advice.LOGIN_CLOSED',
    cardIntact: true,
  },
  PLAN_UNAVAILABLE: {
    tone: 'error',
    titleKey: 'vouchers.result.PLAN_UNAVAILABLE',
    adviceKey: 'vouchers.advice.PLAN_UNAVAILABLE',
    cardIntact: true,
  },
}
